import { render, staticRenderFns } from "./FranchiseDetail.vue?vue&type=template&id=afcaef82&scoped=true&"
import script from "./FranchiseDetail.vue?vue&type=script&lang=js&"
export * from "./FranchiseDetail.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseDetail.vue?vue&type=style&index=0&id=afcaef82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcaef82",
  null
  
)

export default component.exports